import { render, staticRenderFns } from "./ErrorAge.vue?vue&type=template&id=eec12e4e&scoped=true&"
import script from "./ErrorAge.vue?vue&type=script&lang=js&"
export * from "./ErrorAge.vue?vue&type=script&lang=js&"
import style0 from "./ErrorAge.vue?vue&type=style&index=0&id=eec12e4e&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eec12e4e",
  null
  
)

export default component.exports